//--------------- IMPORTAÇÕES ---------------//
import { useContext } from "react";
import { ProdutosContext } from "../context/ProdutosContext";
import { synchronizeProductsService } from "../services"



//--------------- EXPORTAÇÃO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
export default function ContainerActions() {



    //--------------- CRIAÇÃO DOS HOOKS ---------------//
    const { products, setProducts } = useContext(ProdutosContext); // Estado que armazena a lista de Produtos existentes
    const { formData, setFormData } = useContext(ProdutosContext); // Estado que armazena o Objeto Formulário
    const { isModalOpen, setIsModalOpen } = useContext(ProdutosContext); // Estado que armazena se o Modal está aberto ou não
    const { isEditing, setIsEditing } = useContext(ProdutosContext); // Estado que armazena se o usuário está editando ou não
    const { idProductEdited, setIdProductEdited } = useContext(ProdutosContext); // Estado que armazena o ID do Produto editado
    const { isOpenModalCreateProduct, setIsOpenModalCreateProduct } = useContext(ProdutosContext); // Estado que armazena se o Modal de criação de Produto está aberto ou não

    

    //--------------- FUNÇÃO ASSÍNCRONA CARREGAR PRODUTOS ---------------//
    // Responsável por requisitar à API os produtos existentes
    // Armazena no Estado "produtos" a lista de produtos retornadas pela API
    async function handleRefreshProducts() {
        const response = await loadProductsService();
        if (response) {
            setProducts(response.data);
        }
    };



    //--------------- FUNÇÃO ASSÍNCRONA SINCRONIZAR PRODUTOS ---------------//
    // Responsável por sincronizar com a Hotmart via API
    const handleSynchronizeProducts = async () => {
        const response = await synchronizeProductsService();
        if (response) {
            handleRefreshProducts();
        }
    };



    //--------------- RETORNO DO COMPONENTE CONTAINER CREATE COMPANY ---------------//
    return (
        <>

            {/* DIV BUTTONS */}
            <div className="flex gap-4 mb-4 w-full sm:max-w-100 flex-col sm:flex-row">


                {/* BUTTON NOVO PRODUTO */}
                <button
                    onClick={() => setIsOpenModalCreateProduct(true)}
                    className="bg-brand-600 hover:bg-brand-700 px-4 py-2 h-[40px] w-auto rounded flex-2/5 "
                >
                    Novo Produto
                </button>


                {/* BUTTON SINCRONIZAR COM HOTMART */}
                <button
                    onClick={handleSynchronizeProducts}
                    className="bg-blue-600 hover:bg-blue-700 px-4 py-2 h-[40px] w-auto rounded flex-3/5"
                >
                    Sincronizar com Hotmart
                </button>


            </div>

        </>
    )
}